module.exports = __webpack_public_path__ + "img/open-case.b38d6bdb.png";